import { render, staticRenderFns } from "./InvoiceMain.vue?vue&type=template&id=1d4241d8"
import script from "./InvoiceMain.vue?vue&type=script&lang=ts"
export * from "./InvoiceMain.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports